export default __webpack_public_path__ + "static/bubble-with-categories-07c2fd1cce16283a68727bbda9333d8e.png";